<template>
  <div class="min-h-screen bg-surface">
    <div class="max-w-3xl mx-auto px-4 py-12">
      <NuxtLink to="/auth" class="inline-flex items-center gap-1 text-primary mb-8 hover:underline">
        <span class="material-symbols-rounded" style="font-size: 18px;">arrow_back</span>
        Volver
      </NuxtLink>

      <h1 class="text-display-small font-bold text-on-surface mb-2">Política de Privacidad</h1>
      <p class="text-body-medium text-on-surface-variant mb-8">Última actualización: 26 de marzo de 2026</p>

      <div class="prose prose-neutral max-w-none space-y-6 text-body-large text-on-surface/90 leading-relaxed">

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">1. Identidad del responsable del tratamiento</h2>
          <ul class="list-none space-y-1 pl-0">
            <li><strong>Responsable:</strong> Dieter José Lorenzo Molina</li>
            <li><strong>NIF:</strong> 54891162Y</li>
            <li><strong>Domicilio:</strong> Ciempozuelos, Madrid, España</li>
            <li><strong>Correo electrónico:</strong> dieter@comandaplus.com</li>
            <li><strong>Sitio web:</strong> https://app.comandaplus.com</li>
          </ul>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">2. Datos que recopilamos</h2>
          <p>En función de cómo utilices ComandaPlus, podemos recopilar los siguientes datos personales:</p>
          <ul class="list-disc pl-6 space-y-1">
            <li><strong>Datos de registro:</strong> nombre completo, dirección de correo electrónico y contraseña (almacenada de forma cifrada).</li>
            <li><strong>Datos de perfil profesional:</strong> teléfono de contacto, nombre del establecimiento, dirección del establecimiento, tipo de establecimiento.</li>
            <li><strong>Datos de empleados:</strong> nombre, rol y PIN de acceso de los empleados que el usuario registre.</li>
            <li><strong>Datos de operación:</strong> pedidos, cierres de caja, gastos, configuración de mesas y carta del restaurante.</li>
            <li><strong>Datos técnicos:</strong> dirección IP, tipo de navegador, dispositivo y datos de uso generados automáticamente.</li>
          </ul>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">3. Finalidad del tratamiento</h2>
          <p>Tratamos tus datos personales para las siguientes finalidades:</p>
          <ul class="list-disc pl-6 space-y-1">
            <li>Gestionar tu cuenta de usuario y autenticación.</li>
            <li>Prestar el servicio de gestión de hostelería (pedidos, caja, salón, carta).</li>
            <li>Enviar comunicaciones relacionadas con el servicio (cierres de caja por email, notificaciones operativas).</li>
            <li>Mejorar el servicio mediante análisis de uso agregado y anónimo.</li>
            <li>Cumplir con obligaciones legales y fiscales aplicables.</li>
          </ul>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">4. Base legal del tratamiento</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li><strong>Ejecución de un contrato</strong> (Art. 6.1.b RGPD): el tratamiento es necesario para prestar el servicio que has contratado.</li>
            <li><strong>Consentimiento</strong> (Art. 6.1.a RGPD): para el envío de comunicaciones comerciales, si las hubiera.</li>
            <li><strong>Interés legítimo</strong> (Art. 6.1.f RGPD): para la mejora del servicio y la seguridad de la plataforma.</li>
            <li><strong>Obligación legal</strong> (Art. 6.1.c RGPD): para el cumplimiento de obligaciones fiscales y legales.</li>
          </ul>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">5. Destinatarios de los datos</h2>
          <p>Tus datos podrán ser comunicados a los siguientes terceros:</p>
          <ul class="list-disc pl-6 space-y-1">
            <li><strong>Supabase Inc.</strong> — Proveedor de infraestructura y base de datos (servidores en la UE).</li>
            <li><strong>Resend Inc.</strong> — Servicio de envío de correos electrónicos transaccionales.</li>
            <li><strong>Administraciones públicas</strong> — Cuando exista obligación legal (AEAT, autoridades competentes).</li>
          </ul>
          <p>No vendemos ni cedemos tus datos a terceros con fines comerciales.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">6. Transferencias internacionales</h2>
          <p>Algunos de nuestros proveedores pueden estar ubicados fuera del Espacio Económico Europeo. En esos casos, las transferencias se realizan bajo garantías adecuadas conforme al RGPD (cláusulas contractuales tipo de la Comisión Europea o decisiones de adecuación).</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">7. Plazo de conservación</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li><strong>Datos de cuenta:</strong> mientras mantengas tu cuenta activa y durante los plazos legales posteriores.</li>
            <li><strong>Datos de operación</strong> (pedidos, cierres de caja): mínimo 4 años conforme a la normativa fiscal española.</li>
            <li><strong>Datos técnicos y de uso:</strong> máximo 12 meses.</li>
          </ul>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">8. Tus derechos (ARCO-POL)</h2>
          <p>Conforme al RGPD y la LOPD-GDD, tienes derecho a:</p>
          <ul class="list-disc pl-6 space-y-1">
            <li><strong>Acceso:</strong> conocer qué datos personales tratamos sobre ti.</li>
            <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos.</li>
            <li><strong>Supresión:</strong> solicitar la eliminación de tus datos cuando ya no sean necesarios.</li>
            <li><strong>Oposición:</strong> oponerte al tratamiento de tus datos en determinadas circunstancias.</li>
            <li><strong>Portabilidad:</strong> recibir tus datos en un formato estructurado y de uso común.</li>
            <li><strong>Limitación:</strong> solicitar la limitación del tratamiento de tus datos.</li>
          </ul>
          <p>Para ejercer estos derechos, envía un correo electrónico a <strong>dieter@comandaplus.com</strong> indicando el derecho que deseas ejercer y adjuntando copia de tu documento de identidad.</p>
          <p>También puedes ejercer el derecho de supresión y portabilidad directamente desde tu perfil en la aplicación.</p>
          <p>Si consideras que el tratamiento de tus datos no es adecuado, puedes presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> en <a href="https://www.aepd.es" target="_blank" rel="noopener" class="text-primary hover:underline">www.aepd.es</a>.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">9. Seguridad</h2>
          <p>Adoptamos medidas técnicas y organizativas adecuadas para proteger tus datos personales: cifrado en tránsito (TLS), cifrado en reposo, control de acceso basado en roles (RLS), y auditoría de accesos.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">10. Modificaciones</h2>
          <p>Nos reservamos el derecho de actualizar esta política de privacidad. Cualquier cambio será publicado en esta página con la fecha de última actualización. Te recomendamos revisarla periódicamente.</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: false,
})

useHead({
  title: 'Política de Privacidad — ComandaPlus',
})
</script>
